<div class="main-wrap">
  <div class="button-container">
    <div class="add-button-wrap">
      <p-button label="Add Guide" routerLink="/management/create-guide"></p-button>
    </div>

    <div class="search-box">
      <div class="ui-inputgroup">
        <input pInputText  placeholder="search term here" type="text" [(ngModel)]="searchTerm">
        <span class="ui-inputgroup-addon"><i class="pi pi-search" style="line-height: 1.25;"></i></span>
      </div>
    </div>
  </div>
  <div class="table-wrap">
    <p-table selectionMode="single" [value]="guides | jsonFilter:[searchTerm, searchOption]">
      <ng-template pTemplate="header">
        <tr>
          <th id="id-head">ID</th>
          <th>Name</th>
          <th>Created By</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-guide>
        <tr [pSelectableRow]="guide" (click)="editGuide(guide.id)">
          <td>
            {{guide.id}}
          </td>
          <td>
            {{guide.name}}
          </td>
          <td>
            <span  *ngIf="guide.createdBy">
              {{guide.createdBy.name}}
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
